import React from 'react'
import GameCard from './game-card'

export default function Cards(props) {
  const { events, unseen, newLocations, gamesSelector, isLoading } = props

  const eventSelected = (event) => {
    if (!gamesSelector.enabled) return

    return gamesSelector.selected.indexOf(event.id) != -1
  }

  return <div className='panel-body' id='reservation-cards-panel'>
    { isLoading && <div className='animated-spinner'></div> }
    <div className={`'card-deck ${isLoading ? 'isLoading' : ''}`}>
    { 
      events.map((event, index) => {
        return <GameCard
          selected={eventSelected(event)}
          onGamesSelect={props.onGamesSelect}
          event={event}
          eventIndex={index}
          newLocations={props.newLocations}
          unseen={event.channel_id && unseen.includes(event.channel_id)}
          key={index}
          onUpdateWithFacility={props.onUpdateWithFacility}
          onTodoChange={props.onTodoChange}
          onShowGameModal={props.onShowGameModal}
          onEditGame={props.onEditGame}
        /> 
      }) 
    }
    </div>
  </div>
}
